<template>
  <div>
    <div class="show-box-bg wx-login-box">
      <div class="conten">
        <div class="titl">
          <img :src="textmsg.headIndex ? male[textmsg.headIndex].img : male[0].img" alt="" />
          <div class="names">
            {{ textmsg.memberName }}
          </div>
          <div class="names">
            {{ textmsg.group }}
          </div>
        </div>
        <div class="text">
          <div class="medal">他的勋章</div>
          <div class="imsge">
            <div v-if="textmsg.day === 0" class="empty"></div>
            <!-- <img v-if="textmsg.day == 0" src="../../../assets/badge/kong.png" alt=""> -->
            <img
              v-else-if="textmsg.day == 1"
              src="../../../assets/badge/zhou1.png"
              alt=""
            />
            <img
              v-else-if="textmsg.day == 2"
              src="../../../assets/badge/zhou3.png"
              alt=""
            />
            <img
              v-else-if="textmsg.day == 3"
              src="../../../assets/badge/zhou2.png"
              alt=""
            />
            <img
              v-else-if="textmsg.day >= 3"
              src="../../../assets/badge/zhou4.png"
              alt=""
            />
            周赛
          </div>
          <div class="imsge">
            <div v-if="textmsg.month === 0" class="empty"></div>
            <img
              v-else-if="textmsg.month == 1"
              src="../../../assets/badge/yue1.png"
              alt=""
            />
            <img
              v-else-if="textmsg.month == 2"
              src="../../../assets/badge/yue3.png"
              alt=""
            />
            <img
              v-else-if="textmsg.month == 3"
              src="../../../assets/badge/yue2.png"
              alt=""
            />
            <img
              v-else-if="textmsg.month >= 3"
              src="../../../assets/badge/yue4.png"
              alt=""
            />
            月赛
          </div>
          <div class="imsge">
            <div v-if="textmsg.quarter === 0" class="empty"></div>
            <img
              v-else-if="textmsg.quarter == 1"
              src="../../../assets/badge/ji1.png"
              alt=""
            />
            <img
              v-else-if="textmsg.quarter == 2"
              src="../../../assets/badge/ji2.png"
              alt=""
            />
            <img
              v-else-if="textmsg.quarter == 3"
              src="../../../assets/badge/ji3.png"
              alt=""
            />
            <img
              v-else-if="textmsg.quarter >= 3"
              src="../../../assets/badge/ji4.png"
              alt=""
            />
            季赛
          </div>
          <div class="imsge">
            <div v-if="textmsg.year === 0" class="empty"></div>
            <img
              v-else-if="textmsg.year == 1"
              src="../../../assets/badge/nian1.png"
              alt=""
            />
            <img
              v-else-if="textmsg.year == 2"
              src="../../../assets/badge/nian2.png"
              alt=""
            />
            <img
              v-else-if="textmsg.year == 3"
              src="../../../assets/badge/nian3.png"
              alt=""
            />
            <img
              v-else-if="textmsg.year >= 3"
              src="../../../assets/badge/nian4.png"
              alt=""
            />
            年赛
          </div>
        </div>

        <div class="btn-box">
          <div class="confirms">
            <button class="butn" @click="operation">确 定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["textmsg"],
  data() {
    return {
      badPorp: false,
      male:[
                {
                    img: require('../../../assets/sculpture/girl1.png'),
                    selected:false
                },
                {
                    img: require('../../../assets/sculpture/girl2.png'),
                    selected:false
                },
                {
                    img: require('../../../assets/sculpture/girl3.png'),
                    selected:false
                },
                {
                    img: require('../../../assets/sculpture/girl4.png'),
                    selected:false
                },
                {
                    img: require('../../../assets/sculpture/girl5.png'),
                    selected:false
                },
                {
                    img: require('../../../assets/sculpture/girl5.png'),
                    selected:false
                },
                {
                    img:require('../../../assets/sculpture/boy1.png'),
                    selected:false
                },
                {
                    img:require('../../../assets/sculpture/boy2.png'),
                    selected:false
                },
                {
                    img:require('../../../assets/sculpture/boy3.png'),
                    selected:false
                },
                {
                    img:require('../../../assets/sculpture/boy4.png'),
                    selected:false
                },
                {
                    img:require('../../../assets/sculpture/boy5.png'),
                    selected:false
                },
                {
                    img:require('../../../assets/sculpture/boy6.png'),
                    selected:false
                },
            ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    operation() {
      this.$emit("clickBttn");
    },
  },
};
</script>

<style scoped lang="scss">
.wx-login-box {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 901;
  .conten {
    width: 400px;
    background: linear-gradient(to bottom, #e5f1ff, #eff6fe, #fafbff);
    z-index: 1000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 14px;
    overflow: hidden;
    .titl {
      width: 90%;
      height: 155px;
      font-size: 17px;
      padding: 0 5%;
      color: #000000;
      text-align: center;
      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin-top: 20px;
      }
      .names {
        height: 25px;
      }
    }
    .text {
      width: 80%;
      height: 140px;
      font-size: 18px;
      color: #000000;
      margin: 0 auto;
      padding: 0 5%;
      border-radius: 10px;
      background-color: #ffffff;
      text-align: center;
      position: relative;
      .medal {
        color: #deeff5;
        width: 90px;
        height: 30px;
        font-size: 13px;
        line-height: 30px;
        background-color: #007aff;
        background-image: linear-gradient(to right, #47c6f8, #45acf6, #3c90f1);
        border-radius: 10px 0 10px 0;
        position: absolute;
        left: 0;
        top: 0;
      }
      .imsge {
        width: 25%;
        height: 65px;
        float: left;
        font-size: 12px;
        margin-top: 42px;
        z-index: 33;
        .empty {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin: 0 auto 10px;
          background: #f3f3f3;
        }
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin: 0 auto 10px;
          display: block;
        }
      }
    }
    .memberY {
      width: 90%;
      font-size: 28px;
      color: #ffcc00;
      padding: 0 5%;
      text-align: center;
    }
    .memberB {
      width: 90%;
      font-size: 28px;
      color: #007aff;
      padding: 0 5%;
      text-align: center;
    }
    .btn-box {
      width: 100%;
      height: 100px;
      display: flex;
      .confirms {
        width: 100%;
        height: 100%;
        text-align: center;
        .butn {
          color: #ffffff;
          width: 40%;
          font-size: 17px;
          height: 50px;
          margin: 15px 0;
          line-height: 30px;
          border: none;
          border-radius: 30px;
          letter-spacing: 1.5px;
          background: linear-gradient(to left, #2d8aff, #2da3ff, #2dc1ff);
        }
      }
    }
  }
}
</style>